module.exports = __webpack_public_path__ + "static/img/home_header_bkg.0658c6c9.png";